import React, {useMemo} from "react";
import classes from "./container.module.css";
import cn from "classnames";
import {useHistory} from "react-router";

export default function Container({className, ...props}: React.ComponentProps<"div">) {
  const history = useHistory();

  const membersPage = useMemo(() => {
    return history
    && history.location
    && history.location.pathname.includes("members")
    && history.location.pathname.includes("account")
    && !history.location.pathname.includes("groups")
    ? true
    : false
  }
, [history]);

  return <div className={cn(classes.root, membersPage ? classes.rootMembers : null, className)} {...props}/>
}
